var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXls(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "XLS",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15597",
    "data-name": "Rectangle 15597",
    width: 32,
    height: 32,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_84152",
    "data-name": "Group 84152",
    transform: "translate(-22069.947 -8464)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49170",
    "data-name": "Path 49170",
    d: "M26.126,10.552l-4.5,5.185v2.188h1.1V16.5h5.008v-3.7H26.63v2.6H23.387l3.243-3.733h9.125v6.267h1.105V10.552Z",
    transform: "translate(22056.379 8458.448)",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49174",
    "data-name": "Path 49174",
    d: "M57.852,51.1v5.639l-2.473,0-1.016,1.105,4.595,0V51.1Z",
    transform: "translate(22034.281 8431.752)",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49175",
    "data-name": "Path 49175",
    d: "M21.625,56.1v5.781l4.6,0L25.2,60.783l-2.475,0V56.1Z",
    transform: "translate(22056.379 8427.702)",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49176",
    "data-name": "Path 49176",
    d: "M37.68,57.974V62.8l-1.96-1.96-.782.78,3.294,3.3,3.294-3.3-.781-.78L38.785,62.8V57.974Z",
    transform: "translate(22047.395 8426.439)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49177",
    "data-name": "Path 49177",
    d: "M1.942-2.707.045-5.25h1.35L2.618-3.555,3.832-5.25h1.3L3.263-2.715,5.287,0H3.937L2.588-1.875,1.245,0h-1.3ZM6.217-5.25H7.35V-1H10.2V0H6.217ZM13.507.082a2.617,2.617,0,0,1-1.485-.405,1.937,1.937,0,0,1-.81-1.118l1.095-.247a1.4,1.4,0,0,0,.469.619,1.276,1.276,0,0,0,.731.191,1.257,1.257,0,0,0,.72-.18.562.562,0,0,0,.262-.487.448.448,0,0,0-.176-.371,1.221,1.221,0,0,0-.559-.2l-.922-.135a1.851,1.851,0,0,1-1.076-.48,1.336,1.336,0,0,1-.371-.983,1.423,1.423,0,0,1,.259-.84,1.714,1.714,0,0,1,.716-.574A2.511,2.511,0,0,1,13.4-5.332a2.547,2.547,0,0,1,1.41.364,1.814,1.814,0,0,1,.765,1.046l-1.065.24a1,1,0,0,0-.428-.517,1.389,1.389,0,0,0-.727-.18,1.088,1.088,0,0,0-.634.165.514.514,0,0,0-.236.442q0,.45.653.547l.87.113a2.231,2.231,0,0,1,1.222.476,1.3,1.3,0,0,1,.4,1.009,1.54,1.54,0,0,1-.266.9,1.74,1.74,0,0,1-.746.6A2.705,2.705,0,0,1,13.507.082Z",
    transform: "translate(22078 8482)",
    fill: "#707070"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/XLS.8de06b2e539d6e12013e8762a6efdd71.svg";
export { ForwardRef as ReactComponent };